<mat-form-field
  [appearance]="isInTableHeader ? 'standard' : 'outline'"
  [ngClass]="{ 'w-100': isFullWidth }"
>
  @if (label && !isInTableHeader) {
    <mat-label
      >{{ label }}
      @if (unit) {
        <small>({{ unit }})</small>
      }
      @if (isMultiple && model && model.length) {
        <span>({{ model.length }})</span>
      }
    </mat-label>
  }
  <mat-select
    [(ngModel)]="model"
    [required]="isRequired"
    [multiple]="isMultiple"
    [disabled]="isDisabled"
    [placeholder]="labelPrefix + label"
    (openedChange)="searchText = ''"
    (ngModelChange)="onModelChange()"
    panelClass="cim-select"
  >
    @if (isInTableHeader) {
      <mat-select-trigger>
        {{ label }}
        @if (model?.length > 0) {
          <span>({{ model.length }})</span>
        }
      </mat-select-trigger>
    }
    <input
      placeholder="Search"
      matInput
      [(ngModel)]="searchText"
      class="select-input-search"
    />
    <div class="selection-container">
      <button type="button" mat-button color="primary" (click)="selectAll()">
        Select all
      </button>
      <button type="button" mat-button color="primary" (click)="deselectAll()">
        Deselect all
      </button>
    </div>
    @for (item of list | search: searchText; track $index) {
      <mat-option
        [hidden]="item.hidden == true || (hideMarked && item.marked == true)"
        [value]="item.id"
        >{{ item.name }}</mat-option
      >
    }
  </mat-select>
</mat-form-field>
